
import { useRecoilState } from "recoil";
import { recoilStates } from "src/recoil/recoilStates";
import styled from "styled-components";
import { Divider } from "src/components";

import RoundAccodian2 from "../components/YearBooking/RoundAccodian2";
// import { RoundAccodian } from "../YearBooking";

export default function EventBookingCondition() {
  const [ba] = useRecoilState(recoilStates.eventApplication);
  const cr = ba?.event_booking_rel_club?.find((_cr) => [5].includes(_cr.status_id || 0));

  if (!cr) {
    return <div>내역없음</div>;
  }
  return (
    <Container className="flex-1 d-flex fd-c gap-2">
      <div>
        <div className="bold fs-6">골프장 {cr.club?.name}</div>
      </div>

      <RoundAccodian2 clubRelData={cr} defaultOpened={true} />
      <Divider />

      <div className="d-flex">
        <div className="bold mr-1">보증금</div>
        <div>
          <div className="d-flex gap-1">
            <div>{cr?.deposit?.toLocaleString()} 원</div>
          </div>
        </div>
      </div>
      <Divider />
      <div className="d-flex">
        <div className="bold mr-1">객단가</div>
        <div>
          <div>{cr?.price_per_person?.toLocaleString()} 원</div>
        </div>
      </div>
      <Divider />
    </Container>
  );
}

const Container = styled.div``;
